import { render, staticRenderFns } from "./aiPersonalInformation.vue?vue&type=template&id=d96d8afc&scoped=true"
import script from "./aiPersonalInformation.vue?vue&type=script&lang=js"
export * from "./aiPersonalInformation.vue?vue&type=script&lang=js"
import style0 from "./aiPersonalInformation.vue?vue&type=style&index=0&id=d96d8afc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96d8afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d96d8afc')) {
      api.createRecord('d96d8afc', component.options)
    } else {
      api.reload('d96d8afc', component.options)
    }
    module.hot.accept("./aiPersonalInformation.vue?vue&type=template&id=d96d8afc&scoped=true", function () {
      api.rerender('d96d8afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/aiPersonalInformation.vue"
export default component.exports